import React, { Component, Fragment } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup } from 'reactstrap';
import { ArcaHttpClientList } from '../../../code/ArcaHttpClientList';
import { PrePendText } from './PrePendText';

export class InputLookup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            status: null,
            mandatory: this.props.mandatory,
            fieldValid: null,
            dropdownOpen: false,
            label: this.props.label ?? this.props.fieldname,
            description: this.props.description ?? null,
            items: [],
            prependWidth: this.props.prependWidth ?? '160px',
            showHelp: false,
            inline: this.props.inline ?? false,
            canClear: this.props.canClear ?? false
        };
    }

    async componentDidMount() {
        await ArcaHttpClientList.GetWithCodesAsync(this.props.listName, this.receivedList.bind(this))
    }

    receivedList(list) {
        this.setState({ items: list });
    }

    toggleDropDown() {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) {
            return {
                value: props.value
            };
        }

        return null;
    }

    render() {
        let { prependWidth, showHelp, mandatory, label, description, inline } = this.state;
        let prependText = <PrePendText
            prependWidth={prependWidth}
            mandatory={mandatory}
            label={label}
            description={description}
            showHelp={showHelp}
            onClick={(() => this.setState({ showHelp: !showHelp }))}
        />

        return (

            <Fragment>
                <InputGroup>
                    {!inline ? prependText : null}
                </InputGroup>
                <InputGroup>
                    {inline ? prependText : null}

                    <Input fieldname='label' value={this.state.value} readOnly={true}></Input>
                    <Dropdown /*addonType="append"*/ isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown.bind(this)}>
                        <DropdownToggle className='selectDropdown' caret color="secondary" >
                            Select
                        </DropdownToggle>
                        <DropdownMenu>
                            {this.state.canClear
                                ? <DropdownItem onClick={this.handleUserInput.bind(this, null)}>[Clear field]</DropdownItem>
                                : null}
                            {this.state.items.map((item, key) =>
                                <DropdownItem key={key} onClick={this.handleUserInput.bind(this, item)}>{item.Value}</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>

                </InputGroup>


                {this.props.description && showHelp ?
                    <div className='inputFieldDescription'>
                        {this.props.description}
                    </div>
                    : null}

            </Fragment>
        );
    }

    handleUserInput(item) {

        var valid = true;
        this.props.onUpdate(item?.Value, true, this.props.fieldname, item?.Code);

        this.setState({
            value: item ? item.Value : '',
            fieldValid: valid
        });
    }
}
